export default {
  namespaced: true,
  state: {
    loginDialogVisible: false,
    menus:[],
  },
  mutations: {
    changeMenus(state, data) {
      state.menus = data;
    },
    changeLoginDialogVisible(state, data) {
      state.loginDialogVisible = data;
    },
  },
  action: {},
  getter: {},
};
